export const API_KEYS_URL = 'ui/organization/api_keys';

export const apiKeysQueryKeys = {
  all: [API_KEYS_URL],
};
